var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/file.ts
import "@adornis/buildify/client/components/x-buildify-file-selection.js";
import { BuildifyFile } from "@adornis/buildify/db/BuildifyFile.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/forms/x-input";
import { html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { distinctUntilChanged, filter, map, switchMap } from "rxjs";
import { FILE_KEY, FILE_SCHEMA } from "../../schema/nodes/file.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ content, contentController, controllerBaseKeyPath, host }) => {
  return html`
    <x-buildify-file-selection
      ${contentController.field(...controllerBaseKeyPath, "fileID")}
    ></x-buildify-file-selection>
  `;
};
var file = () => ({
  node: {
    name: FILE_KEY,
    schema: FILE_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.MEDIA,
      label: "Datei",
      icon: "description",
      run: (view) => runInsertNode(FILE_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var NodeFile = class extends BuildifyLitElement {
  constructor() {
    super(...arguments);
    this._file = new RXController(
      this,
      this._data.observable.pipe(
        filter(Boolean),
        map((data) => data.fileID),
        filter(Boolean),
        distinctUntilChanged(),
        switchMap((fileID) => BuildifyFile.getByID(fileID)(BuildifyFile.allFields))
      )
    );
  }
  content({ content, mode }) {
    if (!content?.fileID)
      return html` <x-text> Dieser Upload/Download ist mit keiner Datei verknüpft. </x-text> `;
    if (this._file.isLoading)
      return html` <x-loader></x-loader> `;
    if (!this._file.value)
      return html` <x-text> Ungültige Datei gefunden. </x-text> `;
    if (mode === "print") {
      return html`
        <x-link href=${BuildifyFile.getDownloadLink(content.fileID)} target="_blank">
          <x-flex horizontal crossaxis-center space="sm">
            <x-icon> download </x-icon>
            <x-text>${this._file.value?.meta?.fileName}</x-text>
          </x-flex>
        </x-link>
      `;
    }
    return html`
      <a href=${BuildifyFile.getDownloadLink(content.fileID)} ${css({ textDecoration: "none" })}>
        <x-flex horizontal crossaxis-center space="sm">
          ${this._file.value ? this.getFileImage() : html` <x-icon ${css({ fontSize: "50px", color: "#4d4d4d" })}> upload_file </x-icon> `}
          <x-text
            ${acss({
      "&": {
        fontWeight: "800",
        color: "#4d4d4d",
        fontSize: "16px"
      },
      "&:hover": {
        color: this.colors.accent
      }
    })}
          >
            ${this._file.value.meta?.fileName}
          </x-text>
        </x-flex>
      </a>
    `;
  }
  getFileImage() {
    return html` <x-icon ${css({ fontSize: "50px", color: "#4d4d4d" })}> description </x-icon> `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          display: "inline-block",
          verticalAlign: "middle"
        }
      }
    ];
  }
};
__decorateClass([
  state()
], NodeFile.prototype, "_file", 2);
NodeFile = __decorateClass([
  customElement("node-file")
], NodeFile);
export {
  NodeFile,
  file
};
